import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const PrivcyPolicyDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            
            <div className="col-lg-12">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  
                  <div className="details">
                   
                    <p>
                    This Privacy Policy applies to the website operated by Bhavanya Travel Mart Pvt Ltd.
                     We value your privacy and are committed to protecting your personal information.
                     This policy outlines how we collect, use, share,
                     and safeguard your information when you interact with our website 
                    </p>
                    
                    <h4>Information We Collect</h4>
                    <h6>Personal Information</h6>
                    <p>When you engage with our services, we may collect personal information such as:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Name
                          </li>
                          <li>
                            <FaCheckCircle /> Address
                          </li>
                          <li>
                            <FaCheckCircle /> Email address
                          </li>
                          <li>
                            <FaCheckCircle /> Phone number
                          </li>
                        </ul>
                   <p>
                    This information is necessary to provide our services effectively,
                    such as scheduling repairs, processing payments,
                     and communicating service updates.
                   </p>
                   <h5>Usage Information</h5>
                   <p>We may also collect non-personal data such as</p>
                   <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> 	IP addresses
                          </li>
                          <li>
                            <FaCheckCircle /> Browser type and version
                          </li>
                          <li>
                            <FaCheckCircle /> Browsing behavior on our website
                          </li>
                          <li>
                            <FaCheckCircle /> Device information
                          </li>
                        </ul>
                    <p>
                    This data is used to improve 
                    our website's functionality, enhance user experience, and analyze trends.
                    </p>
                    <h4>How We Use Your Information</h4>
                    <h5>Service Delivery</h5>
                    <p>To provide and manage our services, including diagnosing appliance issues,
                     coordinating appointments, and communicating service updates.</p>
                     <h5>Communication</h5>
                     <p>To respond to inquiries, offer customer support,
                      and send relevant updates or promotional materials related to our services.</p>
                      <h5>Service Improvement</h5>
                      <p>To analyze collected data for improving service quality, 
                      resolving technical issues, and developing new features or offerings.</p>
                      <h4>Information Sharing</h4>
                      <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> We do not sell, trade, or lease your personal information to third parties.
                          </li>
                          <li>
                            <FaCheckCircle /> However, to ensure seamless service delivery, we may share necessary details with trusted service providers or technicians involved in fulfilling your requests.
                          </li>
                          <li>
                            <FaCheckCircle /> All third parties are contractually obligated to use your information solely for service-related purposes and to comply with applicable privacy laws.
                          </li>
                          
                        </ul>
                        <h4>Data Security</h4>
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> We employ appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, alteration, or destruction.
                          </li>
                          <li>
                            <FaCheckCircle /> Our security practices adhere to industry standards, including encryption, secure servers, and regular system monitoring.
                          </li>
                         
                          
                        </ul>
                    <h4>Cookies and Tracking Technologies</h4>
                    <p>Our website may use cookies or similar technologies to:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Enhance your browsing experience
                          </li>
                          <li>
                            <FaCheckCircle /> Analyze website traffic
                          </li>
                          <li>
                            <FaCheckCircle /> Understand user interactions
                          </li>
                         
                          
                        </ul>

                        <p>
                        You can manage your cookie preferences through your browser settings.
                        </p>
                        <h4>
                        Third-Party Links
                        </h4>
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Our website may contain links to third-party websites or services.
                          </li>
                          <li>
                            <FaCheckCircle /> We are not responsible for the privacy practices or content of external sites. We encourage you to review the privacy policies of any third-party websites you visit.
                          </li>
                          
                         
                          
                        </ul> 
                <h4>
                Your Rights
                </h4>
                <h5>You have the right to:</h5>
                <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> Access your personal information
                          </li>
                          <li>
                            <FaCheckCircle /> Update or correct inaccuracies
                          </li>
                          <li>
                            <FaCheckCircle /> Request deletion of your data subject to legal and contractual obligations
                          </li>
                          
                         
                          
                        </ul> 
                        <p><b>To exercise these rights, please contact us at the details provided below.</b></p>
                  <h4>Policy Updates</h4>
                  <ul className="single-list-inner style-check style-check mb-3">
                          <li>
                            <FaCheckCircle /> We may update this Privacy Policy to reflect changes in our practices, technology, or legal requirements.
                          </li>
                          <li>
                            <FaCheckCircle /> Updates will be posted on this page, and the "Last Updated" date will be revised accordingly.
                          </li>
                         
                        </ul> 

                        <h4>Contact Us</h4>
                        <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at: </p>
                        <p><b>Phone:  6363169466</b></p>
                        <p><b>Email : info@bhavanyatravelmart.com</b></p>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default PrivcyPolicyDetails;

